import { ref, onMounted, onUnmounted } from 'vue';

export function useScrollNav() {
  const isVisible = ref(true);
  const isScrolled = ref(false);
  const lastScrollY = ref(0);
  const scrollThreshold = 10;
  const hideThreshold = 100; // Additional pixels to scroll down before hiding

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    // Track if user has scrolled down
    isScrolled.value = currentScrollY > scrollThreshold;

    // Don't hide nav at very top of page
    if (currentScrollY <= scrollThreshold) {
      isVisible.value = true;
      lastScrollY.value = currentScrollY;
      return;
    }

    const scrollDifference = currentScrollY - lastScrollY.value;

    // Scrolling down - hide nav only after scrolling hideThreshold pixels down
    if (scrollDifference > hideThreshold && currentScrollY > scrollThreshold) {
      isVisible.value = false;
      lastScrollY.value = currentScrollY;
    }
    // Scrolling up - show nav immediately
    else if (currentScrollY < lastScrollY.value) {
      isVisible.value = true;
      lastScrollY.value = currentScrollY;
    }
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  return {
    isVisible,
    isScrolled
  };
}